import SimpleStatsCard from '@features/analytics/SimpleStatsCard';

const GrossSalesCard = () => {
  return <SimpleStatsCard label="Gross Sales" val={10} />;
};

export default GrossSalesCard;
